var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.927 19.327C11.1014 19.5018 11.3381 19.6 11.585 19.6C11.8319 19.6 12.0686 19.5018 12.243 19.327L16.527 15.043C16.891 14.679 16.891 14.091 16.527 13.727L12.243 9.44299C11.879 9.07899 11.291 9.07899 10.927 9.44299C10.563 9.80699 10.563 10.395 10.927 10.759L14.5483 14.3897L10.927 18.011C10.563 18.375 10.5723 18.9723 10.927 19.327Z",
    fill: "current",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d395fb75c0f0ce4da67306b859829a76.svg";
export { ForwardRef as ReactComponent };